/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No tournaments found" |
*
* @param {Tournaments_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_no_results = /** @type {((inputs?: Tournaments_No_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_No_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun tournoi trouvé")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron torneos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum torneio encontrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun torneo trovato")
	return /** @type {LocalizedString} */ ("No tournaments found")
});